<template>
   <div>
      <el-form
         :model="verifyPhone"
         ref="phone"
         class="checkout-form dashboard-form pl-1 pr-1 pt-1"
         size="small"
         v-loading="loading.save"
      >
      <!-- Telefone -->
      <div class="text-primary mb-2">* Telefone (celular)</div>
      <el-row :gutter="20" class="validate-phone">

         <!-- ID do país -->
         <el-col :span="8" :xs="24" :sm="4">
            <el-form-item>
               <el-input
                  disabled
                  readonly
                  type="text"
                  :value="countryCod"
                  v-model="verifyPhone.countryCod"
               ></el-input>
            </el-form-item>
         </el-col>

         <!-- Input número -->
         <el-col :span="10" :xs="24">
            <el-form-item  prop="number">
               <el-input
                  :readonly="readonly"
                  @change="changePhoneNumber"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  v-model="number"
                  placeholder="(99) 99999-9999"
               ></el-input>
            </el-form-item>
         </el-col>
         <!-- Botão Verificar -->
         <el-col :span="10" :xs="24">
            <el-form-item>
               <el-button
                  @click="validateNumber"
                  :type="verifiedPhone ? 'primary' : 'blue'"
                  :plain="verifiedPhone"
                  size="mini"
                  class="text-uppercase font-weight-bold btn-validate w-100"
                  :loading="loading.validateNumber"
                  :disabled=" this.loading.dataUser || verifiedPhone || !number"
               >
                     <span v-if="verifiedPhone">
                        <i class="el-icon-circle-check mr-1"></i> Verificado
                     </span>
                  <span v-else>
                        Verificar Número
                     </span>

               </el-button>
            </el-form-item>
         </el-col>
      </el-row>
         <el-row>
            <!-- Alterar número (modo leitura) -->
            <el-col :span="12">
               <el-button
                  title="Para alterar seu número, clique aqui."
                  type="text"
                  @click="() => this.$router.push({name: 'profile', })"
                  size="mini"
                  class="text-uppercase font-weight-bold"
               > Alterar número
               </el-button>
            </el-col>
         </el-row>
      </el-form>

      <!-- Modal Verificação de Número-->
      <el-dialog
         title="Verificação de Número"
         :visible.sync="dialogValidateNumber"
         :before-close="dialogValidateNumberClose"
         width="40%"
         class="modal-responsive"
         :close-on-click-modal="false"
         :close-on-press-escape="false"
      >

         <span>Enviamos um código de 6 dígitos para o número informado. Por favor, digite o código abaixo:</span>

         <el-form
            :model="validateNumberCode"
            :rules="validateNumberCodeRules"
            ref="validateNumberCode"
            class="mt-4"
         >
            <el-form-item prop="code">
               <el-input
                  size="lg"
                  :disabled="loading.btnValidateCode || loading.btnResendCode"
                  v-model="validateNumberCode.code"></el-input>
            </el-form-item>

            <span class="dialog-footer d-flex justify-content-between">
             <el-button
                :loading="loading.btnValidateCode || loading.sendingCode"
                :disabled="loading.btnResendCode"
                type="blue"
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                @click="submitNumberCode('validateNumberCode')"
             >
                <span v-if="loading.sendingCode">Enviando Código...</span>
                <span v-else>Validar Código</span>

             </el-button>

             <el-button
                class="mt-sm-2 ml-lg-0 ml-xl-2"
                :disabled="loading.btnValidateCode || loading.btnResendCode || btnValidateCodeResend"
                :loading="loading.btnResendCode"
                @click="reSendCode"
             >
                <span v-if=" loading.btnResendCode">Enviando...</span>
                <span v-else>Reenviar Código</span>

                <span v-if="countDown > 0"> ({{countDown}})</span></el-button>

        </span>

         </el-form>
      </el-dialog>
   </div>
</template>

<script>
import UserService from '@/services/user.service';
import { onlyNumber } from "@/helpers";

export default {
   name: 'VerifyPhone',
   props: {
      number: String,
      countryCod: {
         type: String,
         default: '+55'
      },
      verifiedPhone: null,
      userId: String,
      btnVerifyInLine: {
         type: Boolean,
         default: true
      },
      readonly: {
         type: Boolean,
         default: false
      }
   },
   data() {
      return {
         verifyPhone: {
            countryCod: '+55'
         },
         loading: {
            save: false,
            validateNumber: false,
            btnValidateCode: false,
            btnResendCode: false,
            sendingCode: false
         },
         dialogValidateNumber: false,
         validateNumberCode: {
            code: null
         },
         validateNumberCodeRules: {
            code: [
               {required: true, message: 'Por favor, digite o código', trigger: 'blur'},
            ],
         },
         btnValidateCodeResend: true,
         countDown: 0,
         firstCodeSubmission: false,
         isChangePhoneNumber: false,
      }
   },
   methods: {
      dialogValidateNumberClose() {
         this.loading.validateNumber = false
         this.dialogValidateNumber = false
         this.btnValidateCodeResend = true
         setTimeout(() => {
            if (!this.btnValidateCodeResend) {
               this.countDown = 60
            }

         }, 100)
      },

      async sendCode() {
         try {

            const phone = this.countryCod + onlyNumber(this.number)
            await UserService.valNumberSendCode(phone)
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.loading.sendingCode = false
            this.countDown = 60
            this.countDownTimer()

            this.$message({
               message: "O Código Pedale foi enviado para o seu celular.",
               type: 'success'
            });

         } catch (e) {
            this.$message({
               message: "Solicitação indisponível no momento. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      countDownTimer() {
         if (this.countDown > 0) {
            setTimeout(() => {
               this.countDown -= 1
               this.countDownTimer()
            }, 1000)
         } else {
            this.btnValidateCodeResend = false
         }
      },

      submitNumberCode(formName) {
         this.$refs[formName].validate(async (valid) => {
            this.loading.btnValidateCode = true;

            if (valid) {

               try {
                  await UserService.valNumberVerifyCode(this.validateNumberCode.code)

                  this.$message({
                     message: "Número verificado com sucesso! Obrigado.",
                     type: 'success'
                  });

                  await this.getUser()

                  this.verifiedPhone = true
                  this.isChangePhoneNumber = false
                  this.loading.btnValidateCode = false
                  this.loading.validateNumber = false
                  this.dialogValidateNumber = false
                  this.redirectedByNotVerifiedPhone = true

                  // const data = this.user;
                  // data._id = this.currentUser.user._id;

                  // await this.axios.put(`${this.baseUrl + this.apiV1}/user/update`, {data}, header)

                  // await this.getUser()

               } catch (e) {
                  this.loading.btnValidateCode = false;
                  this.loading.validateNumber = false
               }

            } else {
               this.$message({
                  message: "Por favor, informe o código!",
                  type: 'warning'
               });
               this.loading.btnValidateCode = false;
               return false;
            }
         });
      },

      async reSendCode() {
         try {
            this.loading.btnResendCode = true
            this.validateNumberCode.code = null
            this.loading.btnResendCode = true
            this.loading.sendingCode = true

            await this.sendCode()
            this.loading.btnResendCode = false
            this.btnValidateCodeResend = true
            this.countDown = 60
            this.countDownTimer()

         } catch (e) {
            this.$message({
               message: "Não foi possível enviar o código. Tente novamente mais tarde.",
               type: 'danger'
            });
         }

      },

      async validateNumber() {
         this.loading.validateNumber = true
         this.dialogValidateNumber = true

         if (this.countDown > 1) {
            return false
         } else {
            this.loading.sendingCode = true
            await this.sendCode()
         }

      },

      changePhoneNumber() {
         this.editProfile = true
         this.isChangePhoneNumber = true
         this.verifiedPhone = false
      },

      //Obtem os dados do usuário.
      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },
   },
   computed: {
      userData() {
         return this.$store.state.user
      }
   },
}
</script>

<style scoped>

</style>
